export default {
    heading: "Request access to a patient's MedMatchNet m-Card",
    intro: 'To view their health information, request access. The patient will be asked to approve.',
    npi: 'Your NPI number',
    name: 'Your name',
    practice: 'Practice (optional)',
    contact: 'Email or phone (optional)',
    submit: 'Request access',
    log_in: 'I have a MedMatch account',
    sent_heading: 'Request sent',
    sent_message:
        'The patient has been notified. Nothing is shared until they approve. If they do, MedMatch sends a link to the contact it has on file for your NPI.',
    sent_account_hint: 'To open the m-Card once it is shared, sign in with the MedMatch account that uses this NPI.',
    invalid_heading: 'This link is no longer available',
    invalid_message: 'Ask the patient to show you their current m-Card QR code.',
    errors: {
        npi_invalid: 'Enter a valid 10-digit NPI number.',
        rate_limited: 'There have been too many requests. Please try again later.',
        failed: 'We could not send your request. Please try again.',
    },
}
